import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { clearCrossSell, clearCustomer, clearCustomerDataOld, i18n, openCallMeModal, PartnerEnum, RootState, setCrossSell, setCustomer, setSoIdWeb, setExamDraft, setFlowType, setProgressBarPercentage, useAppDispatch, useAppSelector, setSoId } from 'src/common';
import { CrossSellInput, CrossSellSource } from 'src/common/api/apollo/additional/types/types';
import { ArrowRightIcon, Button, Card, Flex, InputBirthDate, RequestAgentCardV2, Text } from 'src/components';
import { AdditionalKpiInfoCard } from 'src/components/cards/additional/additionalKpiInfo.card';
import { colors, footer, header } from 'src/theme';
import { AppRoutesAdditional, AppRoutesAdditionalCrossell } from '../../_router/app.routes';

// Wrapper so AdditionalKpiInfoCard sticks to footer
const PageWrapperStyle = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minHeight: `calc(100vh - ${header.mobileHeight}px - ${footer.mobileHeight}px)`,
  marginBottom: -40,

  '@media (min-width: 576px)': {
    minHeight: `calc(100vh - ${header.height}px - ${footer.height}px)`,
  },
});


const CustomerOnlyDateBrziPregledPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const isCrossell = pathname.includes('dodatno-zdravstveno-osiguranje-crossell');
  const routes = isCrossell ? AppRoutesAdditionalCrossell : AppRoutesAdditional;
  const customerData = useAppSelector((state: RootState) => state.model.customer.data);


  useEffect(() => {
    dispatch(setSoIdWeb(null));
    dispatch(setSoId(null));
    dispatch(clearCustomer());
    dispatch(setExamDraft(null));
    dispatch(setFlowType('web'));
    dispatch(setProgressBarPercentage(0));
    dispatch(clearCustomerDataOld());

    if (isCrossell) {
      const adminId = searchParams.get('adminId');
      const note = searchParams.get('note');
      const productTypeCode = searchParams.get('productTypeCode');
      const sourceParam = searchParams.get('source');
      const sourceId = searchParams.get('sourceId');
      const newSoSource = searchParams.get('newSoSource');
      const hasAny = adminId || note || productTypeCode || sourceParam || sourceId || newSoSource;
      if (hasAny) {
        const source = sourceParam && (Object.values(CrossSellSource) as string[]).includes(sourceParam)
          ? (sourceParam as CrossSellSource)
          : undefined;
        const payload: CrossSellInput = {
          ...(adminId ? { adminId } : {}),
          ...(note ? { note } : {}),
          ...(productTypeCode ? { productTypeCode } : {}),
          ...(source ? { source } : {}),
          ...(sourceId ? { sourceId } : {}),
          ...(newSoSource ? { newSoSource } : {}),
        };
        dispatch(setCrossSell(payload));
        setSearchParams({}, { replace: true });
      }
    } else {
      dispatch(clearCrossSell());
    }
  }, []);


  const [dateOfBirth, setDateOfBirth] = useState<string>('');
  const [dateError, setDateError] = useState<string>('');

  const handleSubmit = () => {
    if (!dateOfBirth || dateOfBirth.length < 10) {
      setDateError(i18n.t('validation.required'));
      return;
    }
    setDateError('');
    // Navigate to step-2 with date of birth in URL. partnerSource rides Redux to step-3 (createSoAdditional).
    dispatch(setCustomer({ ...customerData, birthDate: dateOfBirth, partnerSource: PartnerEnum.BRZIPREGLED }));
    navigate(`${routes.HEALTH_EXAMS.fullPath}/${dateOfBirth}`);
  };


  return (
    <PageWrapperStyle>
      <Flex vertical align="center" gap={16} style={{ paddingTop: 8, paddingBottom: 16, flex: 1 }}>
        <Card title={<Text type="large" bold style={{ marginBottom: 32 }}>{i18n.t('pages.customerOnlyDate.title')}</Text>}>
          <Flex vertical gap={24} style={{ marginTop: 32 }}>
            {/* Date input section */}
            <Flex vertical gap={8}>
              <Text type="medium">
                {i18n.t('pages.customerOnlyDate.birthDateQuestion')}
              </Text>
              <InputBirthDate
                onChange={(value: string) => {
                  setDateOfBirth(value);
                  if (dateError) setDateError('');
                }}
                id="birthDate"
                error={dateError}
              />
            </Flex>

            {/* Submit button */}
            <Button
              onClick={handleSubmit}
              btnType="primary"
              size="large"
              text={i18n.t('pages.customerOnlyDate.nextButton')}
              className="btnBlock"
            >
              <ArrowRightIcon color={colors.white} />
            </Button>
          </Flex>
        </Card>

        {/* Request agent section */}
        <RequestAgentCardV2
          title={i18n.t('pages.customerOnlyDate.hasQuestion')}
          buttonLabel={i18n.t('pages.customerOnlyDate.requestAgentCall')}
          onButtonClick={() => dispatch(openCallMeModal())}
          background={colors.background6}
        />
      </Flex>

      {false && <AdditionalKpiInfoCard />}
    </PageWrapperStyle>
  );
};

export default CustomerOnlyDateBrziPregledPage;
